
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppButton, AppCard, AppSwitch } from '@/components';
import { useFacebook } from '@/modules/facebook/model/edit';
import { ROUTE_NAME_FACEBOOK } from '@/modules/facebook/router';

export default defineComponent({
    name: ROUTE_NAME_FACEBOOK,
    components: { AppFormRow, AppInput, AppButton, AppCard, AppSwitch },
    setup() {
        const { model, v$, fetch, actions } = useFacebook();

        onMounted(async () => {
            await fetch();
        });

        return { v$, model, actions };
    }
});
